export const statuses = {
    NOT_STARTED: 'NOT_STARTED',
    ACTIVE: 'ACTIVE',
    PENDING_REVIEW: 'PENDING_REVIEW',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED_BY_ADMIN'
};

export const registrationStatuses = {
    NOT_STARTED: 'NOT_STARTED',
    IN_PROGRESS: 'IN_PROGRESS',
    INTERNAL: 'INTERNAL',
    FINISHED: 'FINISHED'
};

export const countDownModeTypes = {
    START: 'start',
    END: 'end',
    MIXED: 'mixed'
};

export const RACE_RULE_STATUSES = {
    active: 'ACTIVE',
    approved: 'APPROVED',
    completed: 'COMPLETED'
};

export const RACE_RULES_TRIGGER_TYPE = 'GAME_ROUND';

export const COUNT_DOWN_FORMAT = {
    mmSS: 'mm_ss',
    hhMM: 'hh_mm',
    ddHHmm: 'dd_hh_mm'
};
